<template>
    <div>
        <e-dialog
                dialog-title="份额变动记录"
                :center-dialog-visible="shareChangeVisible"
                popup-width="900px"
                :onlyShowCancel="true"
                @resetPopupData="handleClose"
        >
            <div>
                <e-search
                        class="margin-b20"
                        :data="filterInfo.data"
                        :field-list="filterInfo.fieldList"
                        :list-type-info="listTypeInfo"
                        @handleFilter="handleFilter"
                        @handleReset="handleReset"
                ></e-search>
                <tableList
                        class="margin-b20"
                        rowKey="id"
                        :index-show="true"
                        :loading="false"
                        :table-data="tableData"
                        :table-label="tableLabel">
                </tableList>
                <div class="flex-r">
                    <el-pagination
                            background
                            :page-sizes="[10, 20,50,100,200]"
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page="queryData.pageNum"
                            :page-size="queryData.pageSize"
                            :total="queryData.pageTotal"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"/>
                </div>

            </div>
        </e-dialog>
    </div>
</template>

<script>
import eDialog from '@/components/common/e-dialog.vue';
import eSearch from '../../../components/common/e-search.vue';
import tableList from '../../../components/common/e-table-list.vue';
import api from '@/modules/projectA/api/purchase';

export default {
  components: {
    eDialog,
    eSearch,
    tableList
  },
  props: {
    shareChangeVisible: Boolean,
    changeId: Number
  },
  data() {
    return {
      listTypeInfo: {
        changeTypeList: [
          {id: null, name: '全部'},
          {id: 1, name: '扣减'},
          {id: 2, name: '返还'},
        ],
      },
      checked: false,
      filterInfo: {
        data: {
          type: null,
        },
        fieldList: [
          {label: '变动类型', type: 'select', value: 'type', list: 'changeTypeList',},
          {
            label: '时间周期', type: 'date',
            value: 'submitTime',
            dateType: "datetimerange",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            defaultTime: ["00:00:00", "23:59:59"]
          },
        ],
      },
      tableData: [],
      tableLabel: [
        {
          label: '变动类型', param: 'type', align: 'center', render: (row) => {
            let obj = {
              1: '扣减',
              2: '返还',
            };
            return obj[row.type];
          }
        },
        {
          label: '变动金额', param: '', align: 'center', render: (row) => {
            return row.type === 1 ? '￥' + row.reduceAmount : '￥' + row.returnAmount;
          },
        },
        {label: '操作人', param: 'createBy', align: 'center',},
        {label: '操作时间', param: 'createTime', align: 'center',},
      ],
      queryData: {
        type: null,
        submitTime: null,
        createTimeStart: null,
        createTimeEnd: null,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.purchaseShareConsume();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.purchaseShareConsume();
    },
    handleFilter(val) {
      this.queryData.pageNum = 1;
      if (val.submitTime && val.submitTime.length > 0) {
        this.queryData.createTimeStart = val.submitTime[0];
        this.queryData.createTimeEnd = val.submitTime[1];
      } else {
        this.queryData.createTimeStart = null;
        this.queryData.createTimeEnd = null;
      }
      this.queryData.type = val.type;

      this.purchaseShareConsume();
    },
    handleReset() {
      this.queryData = {
        type: null,
        submitTime: null,
        createTimeStart: null,
        createTimeEnd: null,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      }
      this.purchaseShareConsume();
    },
    handleClose() {
      this.$emit('update:shareChangeVisible', false);
    },
    async purchaseShareConsume() {
      const res = await api.purchaseShareConsume({purchaseShareId: this.changeId, ...this.queryData});
      if (res.code === '200') {
        this.tableData = res.data.records || [];
        this.queryData.pageTotal = res.data.total || 0;
      }
    },
  },
  mounted() {
    this.purchaseShareConsume();
  }
}
</script>

<style scoped>

</style>